
import vaccin from 'assets/icons/vaccine.svg'
import filter from 'assets/icons/mi_filter.svg'
import { useState } from 'react';
import FilterModal from 'components/modal/filter';


export default function NumberDesktop() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleApplyFilters = (filters: any) => {
      console.log("Filter added", filters);
    };

    return (
      <div className="w-[380px] h-[290px]  bg-[#0277B76E] rounded-xl flex items-center justify-center flex-col ">
        <div className="w-[310px] h-[240px] border border-[#FFFFFF] rounded-xl flex items-center justify-center flex-col gap-[10px]">
          <div className="w-[100%] h-[20%] flex items-center justify-center">
            <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] border flex items-center justify-center">
              <img src={vaccin} alt="" />
            </div>
          </div>
          <div className="w-[300px] h-[100px] flex items-center justify-center flex-col">
            <h1 className="text-[60px] font-bold">234</h1>
            <p>Total number of vaccine shots</p>
          </div>
          <div className="w-[300px] h-[60px] flex items-center justify-center">
            <button
              className="w-[180px] h-[40px] rounded-3xl border-[#FFFFFF] border text-[#FFFFFF] flex items-center justify-center gap-[10px]"
              onClick={() => setIsModalOpen(true)}
            >
              <img src={filter} alt="" />
              filter
            </button>
          </div>
        </div>

        <FilterModal
          onApply={handleApplyFilters}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    );
}